import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Button, Input } from '@beef/ui-kit';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { CaptchaInput } from "../../../../components/Captcha/Nectar";
import { PAYMENT_SUBJECT_CONFIG } from "../../../../constants/payment";
import { unformatPhone } from "../../../../utils/formatters";
import { fixMaskMatch } from "../../../../utils/validators";
import { withControlAnalytics } from "../../../../utils/withControlAnalytics";
import { SberPayBinding } from "../../types";
import { LegalBlock } from "../../components/LegalBlock";
import { TextContainer } from "../../components/TextContainer";
import { Validation } from "../../components/Validation";
import { onButtonPressAnalyticsHandler, onPhoneInputAnalyticsHandler } from "../analytics";
import { CAPTCHA_ERROR } from "../constants";
var EnhancedInput = withControlAnalytics('onBlur', onPhoneInputAnalyticsHandler)(Input);
var EnhancedButton = withControlAnalytics('onClick', onButtonPressAnalyticsHandler)(Button);
var PaymentProcess = function PaymentProcess(_ref) {
  var ctn = _ref.ctn,
    isLoading = _ref.isLoading,
    stepsData = _ref.stepsData,
    paymentSubject = _ref.paymentSubject,
    sendSberPaymentRequest = _ref.sendSberPaymentRequest,
    initialCtn = _ref.initialCtn,
    hasCaptcha = _ref.hasCaptcha,
    hasCaptchaError = _ref.hasCaptchaError,
    setHasCaptchaError = _ref.setHasCaptchaError;
  var _React$useState = React.useState(initialCtn || ''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    fromCtn = _React$useState2[0],
    setFromCtn = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    fromCtnError = _React$useState4[0],
    setFromCtnError = _React$useState4[1];
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    captcha = _useState2[0],
    setCaptcha = _useState2[1];
  var captchaErrorMessage = hasCaptchaError ? CAPTCHA_ERROR : undefined;
  var onCaptchaChangeHandler = function onCaptchaChangeHandler(e) {
    setCaptcha(e.target.value);
    setHasCaptchaError(false);
  };
  var handleClick = React.useCallback(function () {
    sendSberPaymentRequest(unformatPhone(ctn), unformatPhone(fromCtn), captcha);
  }, [ctn, fromCtn, captcha]);
  var handleSetFromCtn = React.useCallback(function (e) {
    var formattedCtn = fixMaskMatch(e.target.value, paymentSubject, false);
    setFromCtn(formattedCtn);
  }, [paymentSubject]);
  var isDisabled = !!fromCtnError || !captcha || !!captchaErrorMessage;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextContainer, {
    description: stepsData.description,
    title: stepsData.title
  }), /*#__PURE__*/React.createElement(Validation, {
    fromCtn: fromCtn,
    setFromCtnError: setFromCtnError
  }, function (_ref2) {
    var validateCtn = _ref2.validateCtn;
    return /*#__PURE__*/React.createElement(EnhancedInput, {
      errorMessage: fromCtnError,
      helpMessage: stepsData.inputText,
      maskSettings: {
        mask: ' ',
        format: PAYMENT_SUBJECT_CONFIG.cellphone.mask
      },
      noErrorIndent: true,
      onBlur: validateCtn,
      onChange: handleSetFromCtn,
      placeholder: PAYMENT_SUBJECT_CONFIG.cellphone.placeholder,
      type: "text",
      value: fromCtn
    });
  })), /*#__PURE__*/React.createElement(LegalBlock, {
    text: stepsData.userAgreement
  }, hasCaptcha && /*#__PURE__*/React.createElement(CaptchaInput, {
    errorMessage: captchaErrorMessage,
    onChange: onCaptchaChangeHandler,
    placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u0438\u043C\u0432\u043E\u043B\u044B \u0441 \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438",
    value: captcha
  }), /*#__PURE__*/React.createElement(EnhancedButton, {
    disabled: isDisabled,
    isLoading: isLoading,
    onClick: handleClick
  }, stepsData.buttonText)));
};
PaymentProcess.propTypes = process.env.NODE_ENV !== "production" ? {
  ctn: PropTypes.string,
  initialCtn: PropTypes.string,
  isLoading: PropTypes.bool,
  paymentSubject: PropTypes.oneOf([PAYMENT_SUBJECT_CONFIG.cellphone.id, PAYMENT_SUBJECT_CONFIG.internet.id]),
  stepsData: SberPayBinding,
  sendSberPaymentRequest: PropTypes.func,
  hasCaptcha: PropTypes.bool
} : {};
export default PaymentProcess;